import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .widgets-container-video {
    margin-bottom: 16px;
    border-radius: 12px;
    overflow: hidden;
  }

  .map-wrapper {
    width: 100%;
    min-width: 403px;
    flex: 1 1 50%;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    border-radius: 0 12px 12px 0;

    > * {
      height: auto;
      max-height: 100%;
      min-height: 0;
      overflow-y: auto;
      border-radius: 0 12px 12px 0 !important;
    }
  }

  .map-container {
    border-radius: 0 12px 12px 0;
    width: 100%;
    height: 100%;
  }

  .video-container {
    border-radius: 12px;
    display: flex;
    align-items: stretch;
    overflow: hidden;
    background-color: ${(props) => props.theme.colors.widget_background};
    height: 750px;

    > *:first-child:not(.upload-progress-container):not(.no-video-placeholder) {
      flex: 1 1 50%;
      min-width: 0;
      width: auto;
      height: 100%;
      display: flex;
      align-items: stretch;
      justify-content: center;
      border-radius: 12px;
      overflow: hidden;

      .video-player,
      .plyr,
      .plyr__video-wrapper,
      video {
        border-radius: 12px;
        overflow: hidden;
      }
    }
  }

  .no-video-placeholder {
    flex: 1 1 50%;
    min-width: 0;
    height: 100%;
    border-radius: 12px;
    background-color: ${(props) => props.theme.colors.outline};
  }

  .upload-progress-container {
    flex: 1 1 50%;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 350px;
    padding: 24px;
    background-color: ${(props) => props.theme.colors.outline};
    border-radius: 12px;
  }

  .actions-wrapper {
    width: 100%;
    margin-left: 32px;
    display: flex;
    gap: 16px;

    .border-line {
      content: '';
      height: 44px;
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }
  }
`;

export default { Wrapper };
